import { Input } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '@environments/environment';
import { MobileScreenShotModalComponent } from '@app/_shared/mobile-screen-shot-modal/mobile-screen-shot-modal.component';

@Component({
  selector: 'app-mobile-result-details-modal',
  templateUrl: './mobile-result-details-modal.component.html',
  styleUrls: ['./mobile-result-details-modal.component.less']
})
export class MobileResultDetailsModalComponent {
  @Input() mobileInstruction: any;
  @Input() mostRecentExecuted: any;


  constructor(private activeModal: NgbActiveModal, private modalService: NgbModal) { }

  close() {
    this.activeModal.close();
  }

  downloadFile(gridFsId: any, gridFsName: any): void {
    const modalInstance = this.modalService.open(MobileScreenShotModalComponent, { size: 'lg' });
    modalInstance.componentInstance.mobileInstructionDetails = this.mobileInstruction;
    modalInstance.componentInstance.gridFsId = gridFsId;
    modalInstance.componentInstance.gridFsName = gridFsName;
    modalInstance.componentInstance.mostRecentExecuted = this.mostRecentExecuted;
  }

}
